module.exports = __webpack_public_path__ + "static/media/marker_truck_direita_warning.308b4822.png";